module.exports = __webpack_public_path__ + "c125db248e80a883ff09eb7939df5b58.jpg";